import { withPlaceholder } from '../../Placeholders';
import { PaginatorPlaceholder } from '../../Placeholders/Templates';
import Paginator from '../Paginator';

export default withPlaceholder({
    customPlaceholder: PaginatorPlaceholder
})(Paginator);
